<template>
  <header class="l-header">
    <Button
      :to="{ name: 'room', query: { r: role.query } }"
      class="l-header-back"
    >
      <i class="fas fa-angle-left"></i>
    </Button>
    <div v-if="hasRoomSelected" class="l-header-room">
      <a
        :href="projectTasksUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="l-header-room__link"
      >
        <h2 class="l-header-room__name">{{ roomName }}</h2>
        <img
          src="/assets/icons/NewTab.svg"
          class="l-header-room__icon"
          alt="open new tab icon"
        />
      </a>
    </div>
    <div v-if="hasRoomSelected && isCompany" class="l-header-status">
      <a
        :href="influencerTasksUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="l-header-status__link"
      >
        <Avatar :src="userPicture" class="l-header-status__avatar" />
        <p class="l-header-status__name">{{ userName }}</p>
        <img
          src="/assets/icons/NewTab.svg"
          class="l-header-status__icon"
          alt="open new tab icon"
        />
      </a>
    </div>
    <!-- <div class="l-header-status__logout">
        <Button variant="secondary" size="xs" @click="logout">
          ログアウト
        </Button>
      </div> -->
  </header>
</template>

<script>
import Avatar from '@/components/Avatar';
import Button from '@/components/Button';
import utils from '@/utils';

export default {
  components: {
    Avatar,
    Button
  },
  computed: {
    projects() {
      return this.$store.state.projects;
    },
    role() {
      return this.$store.state.role;
    },
    room() {
      return this.$store.getters.currentRoom;
    },
    roomName() {
      if (!this.room) {
        return '';
      }
      if (utils.isInfluencer(this.role.name)) {
        return utils.getRoomName(this.room);
      }
      return this.room.projectName;
    },
    projectTasksUrl() {
      const projectId = utils.getProjectId(this.room);
      const isCompany = utils.isCompany(this.role.name);
      const baseUrl = isCompany
        ? process.env.VUE_APP_COMPANY_APP_RENEWAL_URL
        : process.env.VUE_APP_INFLUENCER_APP_RENEWAL_URL;
      return `${baseUrl}/projects/${projectId}/tasks`;
    },
    influencerTasksUrl() {
      const baseUrl = process.env.VUE_APP_COMPANY_APP_RENEWAL_URL;
      const projectId = utils.getProjectId(this.room);
      const influencerId = utils.getInfluencerId(this.room);
      return `${baseUrl}/projects/${projectId}/influencers/${influencerId}/tasks`;
    },
    hasRoomSelected() {
      const { partner, project } = this.$store.state.room.current;
      return !!(partner && project);
    },
    isCompany() {
      return utils.isCompany(this.role.name);
    },
    userName() {
      if (!this.room) {
        return '';
      }
      return this.room.partnerName;
    },
    userPicture() {
      if (!this.room) {
        return '';
      }
      return this.room.partnerAvatar;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('setLoading', true);
      this.$nextTick(() => {
        this.$auth.logout();
      });
    }
  }
};
</script>
